const WORDS = ["Guess", "G-Star Raw", "JOOP!", "Camper", "Happy Socks", "Heskimo", "Tiffosi", "Fantasy Sandals", "Dundrum Showrooms", "32 Counties", "Est. 1981"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display text-5xl sm:text-7xl ${i % 2 ? "italic text-[#c8a97e]" : "text-[#f5f3ef]"}`}>{w}</span>
        <svg viewBox="0 0 20 20" className="h-4 w-4 text-[#c8a97e]" aria-hidden="true"><path d="M10 0l2.2 7.8L20 10l-7.8 2.2L10 20l-2.2-7.8L0 10l7.8-2.2z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="marquee-wrap relative overflow-hidden border-y border-white/10 py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
